import { lazy } from 'react'
import { Navigate } from 'react-router'

import { AuthAbout, Login, SharedRequest } from '../components/Auth'
import { EmailRawLayout } from '../components/Email'
import { ErrorPage, ErrorPageNotFound } from '../components/ErrorPage'
import { Layout } from '../components/Layout'
import { Loader } from '../components/Loader'
import {
  RouteRedirectExternal,
  RouteRemoveRedesignPrefix,
} from '../components/Route'
import { APP_STATUS_ERROR } from '../constants/common'
import {
  ROUTE_PATH_LIST,
  ROUTE_PATH_LIST_AUTH,
  ROUTE_PATH_LIST_LEGACY,
  ROUTER_EXTERNAL_REDIRECT_PREFIX,
} from '../constants/route'
import { getMenuItems } from '../utils/menu'
import {
  getAvailableSectionWithRedirectToWebappLoader,
  getLegacyWebappRedirectLoader,
} from '../utils/route'

import { getRequestThreadRawRoutes } from './requestThreadRawRoutes'

const RequestProfile = lazy(() =>
  import('../components/RequestProfile').then(m => ({
    default: m.RequestProfile,
  }))
)

function getWorkerLayoutRoutes() {
  return [
    {
      element: <RequestProfile />,
      path: `${ROUTE_PATH_LIST.serviceRequests}/${ROUTE_PATH_LIST.serviceRequest}`,
    },
    { element: <ErrorPageNotFound />, index: true },
    { element: <ErrorPageNotFound />, path: '*' },
  ]
}

export function getWorkerAppRoutes({ appAvailable }) {
  return [
    {
      HydrateFallback: Loader,
      children: getWorkerLayoutRoutes(),
      element: <Layout getMenuItems={getMenuItems} />,
      errorElement: <ErrorPage status={APP_STATUS_ERROR} />,
      path: '/',
    },
    {
      HydrateFallback: Loader,
      children: getRequestThreadRawRoutes(),
      element: <EmailRawLayout />,
      errorElement: <ErrorPage status={APP_STATUS_ERROR} />,
      path: ROUTE_PATH_LIST.serviceRequestsThreads,
    },
    {
      HydrateFallback: Loader,
      element: <Login />,
      errorElement: <ErrorPage status={APP_STATUS_ERROR} />,
      loader: loaderProps =>
        getAvailableSectionWithRedirectToWebappLoader({
          ...loaderProps,
          hasAccess: appAvailable,
          redirectSectionName: 'login',
        }),
      path: ROUTE_PATH_LIST_AUTH.login(),
    },
    {
      element: <SharedRequest />,
      errorElement: <ErrorPage status={APP_STATUS_ERROR} />,
      path: ROUTE_PATH_LIST_AUTH.sharedRequest,
    },
    {
      element: <AuthAbout />,
      errorElement: <ErrorPage status={APP_STATUS_ERROR} />,
      path: ROUTE_PATH_LIST_AUTH.about,
    },
    // The worker router has no NG profiles, so legacy webapp paths redirect
    // straight back to the webapp.
    {
      loader: getLegacyWebappRedirectLoader(),
      path: ROUTE_PATH_LIST_LEGACY.buildingGroup,
    },
    {
      loader: getLegacyWebappRedirectLoader(),
      path: ROUTE_PATH_LIST_LEGACY.building,
    },
    {
      loader: getLegacyWebappRedirectLoader(),
      path: ROUTE_PATH_LIST_LEGACY.chat,
    },
    {
      loader: getLegacyWebappRedirectLoader(),
      path: ROUTE_PATH_LIST_LEGACY.profile,
    },
    {
      element: <RouteRedirectExternal />,
      path: `/${ROUTER_EXTERNAL_REDIRECT_PREFIX}/*`,
    },
    { element: <RouteRemoveRedesignPrefix />, path: '/redesign/*' },
    { element: <Navigate replace to='/' />, path: '/redesign' },
  ]
}
